import {countries} from 'countries-list'
import {
  formatDate as formatDateLib,
  formatNumber as formatNumberLib,
  formatCurrency as formatCurrencyLib,
  formatPercent as formatPercentLib,
  formatNumberToFixed as formatNumberToFixedLib,
} from '@components/lib'

import {TokenInfo} from 'constData'
import {getCurrentLanguage} from 'i18n/utils'

export const countriesSelectData = Object.entries(countries).map(([code, countryData]) => ({
    value: code.toLowerCase(),
    label: countryData.name || countryData.country,
}));

export const formatDate = (date, format = 'MMM D, YYYY, h:mm A') => formatDateLib(date, format)

export const formatDateWithoutTime = (date, format = 'MMM D, YYYY') => formatDateLib(date, format)

export const formatNumber = (number, options) =>
  formatNumberLib(number, {locales: getCurrentLanguage(), ...options})

export const formatCurrency = (amount, options) =>
  formatCurrencyLib(amount, {locales: getCurrentLanguage(), ...options})

export const formatNumberToFixed = (number, options) =>
  formatNumberToFixedLib(number, {
    number,
    locale: getCurrentLanguage(),
    ...options,
  })

export const formatPercent = (number, options) =>
  formatPercentLib(number != null ? number / 100 : 0, {
    locales: getCurrentLanguage(),
    ...options,
  })

export const isMfaRequired = error => {
  if (Array.isArray(error.errorsObject) && error.errorsObject.length === 1) {
    const err = error.errorsObject[0].toLowerCase()
    return (
      err === 'MFA code is required'.toLowerCase() || err === '2FA code is required'.toLowerCase()
    )
  }
  return false
}

export function isProfileConfirmed(profile) {
  if (!profile) return false
  return profile.email_confirmed
}

// USDT and MBASE 2 digit ETH 6 digit
export const formateFloatCurrency = (asset, amount) => {
  if (['USDT', TokenInfo.MBASE.apiId, TokenInfo.XON.apiId].includes(asset)) {
    return parseFloat(amount).toFixed(2)
  }
  if (asset === 'ETH') {
    return parseFloat(amount).toFixed(6)
  }
  return parseFloat(amount).toFixed(6)
}

export const getDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  const isAndroid = /Android/i.test(userAgent)
  const isiOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  return isAndroid ? 'Android' : isiOS ? 'iOS' : 'Web'
}
